import { InputRule } from '@milkdown/kit/prose/inputrules';
import { $inputRule } from '@milkdown/kit/utils';
import { replace } from 'out-of-character';

import { embedNode } from '../embed';
import { youtubeProvider } from '../providers/youtube';

/**
 * YouTube URL regex pattern for input rule
 * Matches: youtu.be/*, youtube.com/watch?v=*, youtube.com/embed/*, etc.
 *
 * Note: Allows trailing invisible characters (zero-width spaces, etc.) before the $ anchor.
 * These chars are common when copy-pasting from rich text editors. The character class
 * [\u200B-\u200D\uFEFF\u00AD] matches the same set stripped by youtube.ts's stripInvisibleChars.
 *
 * @internal Exported for testing only
 */
export const YOUTUBE_INPUT_REGEX =
  /(?:https?:\/\/)?(?:www\.)?(?:youtube(?:-nocookie)?\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:\/|[?&][^\s]*)?[\u200B-\u200D\uFEFF\u00AD]*$/i;

/**
 * Input rule: pasting/typing a YouTube URL creates an embed block
 */
export const youtubeInputRule = $inputRule(
  (ctx) =>
    new InputRule(YOUTUBE_INPUT_REGEX, (state, match, start, end) => {
      const [rawUrl] = match;
      if (!rawUrl || !youtubeProvider.matcher(rawUrl)) {
        return null;
      }

      // Clean invisible chars before storing in node
      const url = replace(rawUrl);
      const { tr } = state;
      const embedType = 'youtube';

      // Replace the URL text with an embed node
      tr.replaceWith(start, end, embedNode.type(ctx).create({ href: url, embedType }));

      return tr;
    }),
);
